export default __webpack_public_path__ + "static/media/handy-list.277c4822.png";